module.exports = __WEBPACK_EXTERNAL_MODULE_JgyH__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"classnames","commonjs2":"classnames","amd":"classnames","root":"classNames","var":"classNames"}
// module id = JgyH
// module chunks = 0